"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const component_1 = require("../packages/component-framework/component");
const createSwiper_1 = __importDefault(require("../helpers/createSwiper"));
class TestimonialSlider extends component_1.Component {
    constructor(element) {
        super(element);
        this.registerBanner();
    }
    registerBanner() {
        const swiperContainer = document.querySelector('.swiper-2');
        createSwiper_1.default(this.element, {
            loop: false,
            spaceBetween: 50,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            controller: {
                inverse: true,
            },
            autoplay: {
                delay: 5000,
            },
        });
        createSwiper_1.default(swiperContainer, {
            loop: false,
            spaceBetween: 50,
            initialSlide: 0,
            slidesPerView: "auto",
            loopedSlides: 50,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: {
                delay: 5000,
            },
        });
    }
}
exports.default = TestimonialSlider;
TestimonialSlider.selector = '.module-testimonials .swiper-container';
